import styled from 'styled-components';

export const NavSuperior = styled.nav`
  box-shadow: 1px 6px 8px -6px rgba(0, 0, 0, 0.49);
  -webkit-box-shadow: 1px 6px 8px -6px rgba(0, 0, 0, 0.49);
  -moz-box-shadow: 1px 6px 8px -6px rgba(0, 0, 0, 0.49);
`;

export const NavLateral = styled.nav``;
